<script setup lang="ts">
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const { t } = useI18n()
const root = ref<HTMLElement | null>(null)

const slides = [
  // ── Bookings ────────────────────────────────────────────────────────────────
  {
    image: '/overview/appointment-scheduling.svg',
    labelKey: 'page.features.showcase.slide_1_label',
    titleKey: 'page.features.showcase.slide_1_title',
    descKey: 'page.features.showcase.slide_1_desc',
    bullets: [
      'page.features.showcase.slide_1_bullet_1',
      'page.features.showcase.slide_1_bullet_2',
      'page.features.showcase.slide_1_bullet_3',
    ],
  },
  {
    image: '/overview/new_booking.svg',
    labelKey: 'page.features.showcase.slide_2_label',
    titleKey: 'page.features.showcase.slide_2_title',
    descKey: 'page.features.showcase.slide_2_desc',
    bullets: [
      'page.features.showcase.slide_2_bullet_1',
      'page.features.showcase.slide_2_bullet_2',
      'page.features.showcase.slide_2_bullet_3',
    ],
  },
  // ── Financial ────────────────────────────────────────────────────────────────
  {
    image: '/overview/invoicing-pos.svg',
    labelKey: 'page.features.showcase.slide_3_label',
    titleKey: 'page.features.showcase.slide_3_title',
    descKey: 'page.features.showcase.slide_3_desc',
    bullets: [
      'page.features.showcase.slide_3_bullet_1',
      'page.features.showcase.slide_3_bullet_2',
      'page.features.showcase.slide_3_bullet_3',
    ],
  },
  {
    image: '/overview/report.svg',
    labelKey: 'page.features.showcase.slide_4_label',
    titleKey: 'page.features.showcase.slide_4_title',
    descKey: 'page.features.showcase.slide_4_desc',
    bullets: [
      'page.features.showcase.slide_4_bullet_1',
      'page.features.showcase.slide_4_bullet_2',
      'page.features.showcase.slide_4_bullet_3',
    ],
  },
  {
    image: '/overview/new_sale.svg',
    labelKey: 'page.features.showcase.slide_5_label',
    titleKey: 'page.features.showcase.slide_5_title',
    descKey: 'page.features.showcase.slide_5_desc',
    bullets: [
      'page.features.showcase.slide_5_bullet_1',
      'page.features.showcase.slide_5_bullet_2',
      'page.features.showcase.slide_5_bullet_3',
    ],
  },
  {
    image: '/overview/dashboard.svg',
    labelKey: 'page.features.showcase.slide_6_label',
    titleKey: 'page.features.showcase.slide_6_title',
    descKey: 'page.features.showcase.slide_6_desc',
    bullets: [
      'page.features.showcase.slide_6_bullet_1',
      'page.features.showcase.slide_6_bullet_2',
      'page.features.showcase.slide_6_bullet_3',
    ],
  },
  // ── Human Resources ──────────────────────────────────────────────────────────
  {
    image: '/overview/employees_list.svg',
    labelKey: 'page.features.showcase.slide_7_label',
    titleKey: 'page.features.showcase.slide_7_title',
    descKey: 'page.features.showcase.slide_7_desc',
    bullets: [
      'page.features.showcase.slide_7_bullet_1',
      'page.features.showcase.slide_7_bullet_2',
      'page.features.showcase.slide_7_bullet_3',
    ],
  },
  {
    image: '/overview/staff-shifts.svg',
    labelKey: 'page.features.showcase.slide_8_label',
    titleKey: 'page.features.showcase.slide_8_title',
    descKey: 'page.features.showcase.slide_8_desc',
    bullets: [
      'page.features.showcase.slide_8_bullet_1',
      'page.features.showcase.slide_8_bullet_2',
      'page.features.showcase.slide_8_bullet_3',
    ],
  },
  {
    image: '/overview/employee_profile.svg',
    labelKey: 'page.features.showcase.slide_9_label',
    titleKey: 'page.features.showcase.slide_9_title',
    descKey: 'page.features.showcase.slide_9_desc',
    bullets: [
      'page.features.showcase.slide_9_bullet_1',
      'page.features.showcase.slide_9_bullet_2',
      'page.features.showcase.slide_9_bullet_3',
    ],
  },
  // ── Catalog ──────────────────────────────────────────────────────────────────
  {
    image: '/overview/product_details.svg',
    labelKey: 'page.features.showcase.slide_10_label',
    titleKey: 'page.features.showcase.slide_10_title',
    descKey: 'page.features.showcase.slide_10_desc',
    bullets: [
      'page.features.showcase.slide_10_bullet_1',
      'page.features.showcase.slide_10_bullet_2',
      'page.features.showcase.slide_10_bullet_3',
    ],
  },
  {
    image: '/overview/locations.svg',
    labelKey: 'page.features.showcase.slide_11_label',
    titleKey: 'page.features.showcase.slide_11_title',
    descKey: 'page.features.showcase.slide_11_desc',
    bullets: [
      'page.features.showcase.slide_11_bullet_1',
      'page.features.showcase.slide_11_bullet_2',
      'page.features.showcase.slide_11_bullet_3',
    ],
  },
  {
    image: '/overview/services.svg',
    labelKey: 'page.features.showcase.slide_12_label',
    titleKey: 'page.features.showcase.slide_12_title',
    descKey: 'page.features.showcase.slide_12_desc',
    bullets: [
      'page.features.showcase.slide_12_bullet_1',
      'page.features.showcase.slide_12_bullet_2',
      'page.features.showcase.slide_12_bullet_3',
    ],
  },
  // ── Marketing ────────────────────────────────────────────────────────────────
  {
    image: '/overview/reminders.svg',
    labelKey: 'page.features.showcase.slide_13_label',
    titleKey: 'page.features.showcase.slide_13_title',
    descKey: 'page.features.showcase.slide_13_desc',
    bullets: [
      'page.features.showcase.slide_13_bullet_1',
      'page.features.showcase.slide_13_bullet_2',
      'page.features.showcase.slide_13_bullet_3',
    ],
  },
  {
    image: '/overview/gift_card.svg',
    labelKey: 'page.features.showcase.slide_14_label',
    titleKey: 'page.features.showcase.slide_14_title',
    descKey: 'page.features.showcase.slide_14_desc',
    bullets: [
      'page.features.showcase.slide_14_bullet_1',
      'page.features.showcase.slide_14_bullet_2',
      'page.features.showcase.slide_14_bullet_3',
    ],
  },
  {
    image: '/overview/client_profile.svg',
    labelKey: 'page.features.showcase.slide_15_label',
    titleKey: 'page.features.showcase.slide_15_title',
    descKey: 'page.features.showcase.slide_15_desc',
    bullets: [
      'page.features.showcase.slide_15_bullet_1',
      'page.features.showcase.slide_15_bullet_2',
      'page.features.showcase.slide_15_bullet_3',
    ],
  },
]

onMounted(() => {
  const el = root.value
  if (!el) return

  gsap.fromTo(el.querySelector('.fsw-heading'),
    { opacity: 0, y: 40 },
    {
      opacity: 1, y: 0, duration: 0.75, ease: 'power3.out',
      scrollTrigger: { trigger: el, start: 'top 80%', once: true },
    },
  )

  el.querySelectorAll<HTMLElement>('.fsw-row').forEach((row) => {
    gsap.fromTo(row.querySelector('.fsw-row-text'),
      { opacity: 0, y: 36 },
      {
        opacity: 1, y: 0, duration: 0.85, ease: 'power3.out',
        scrollTrigger: { trigger: row, start: 'top 82%', once: true },
      },
    )
    gsap.fromTo(row.querySelector('.fsw-row-image'),
      { opacity: 0, scale: 0.94, y: 24 },
      {
        opacity: 1, scale: 1, y: 0, duration: 0.9, ease: 'back.out(1.2)',
        scrollTrigger: { trigger: row, start: 'top 82%', once: true },
      },
    )
  })
})
</script>

<template>
  <section ref="root" class="bg-white">

    <!-- Header -->
    <div class="fsw-heading container py-16 md:py-20 lg:py-24 pb-0">
      <h2 class="text-[clamp(1.75rem,3.5vw,2.75rem)] font-black text-deep-indigo leading-tight mb-3">
        {{ $t('page.features.showcase.title') }}
      </h2>
      <p class="text-base md:text-lg text-gray-500 max-w-xl leading-relaxed">
        {{ $t('page.features.showcase.subtitle') }}
      </p>
    </div>

    <!-- Rows -->
    <div
      v-for="(slide, i) in slides"
      :key="slide.titleKey"
      class="fsw-row py-12 md:py-16 lg:py-20"
      :class="i % 2 === 0 ? 'bg-white' : 'bg-gray-50'">

      <div class="container grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 xl:gap-20 items-center">

        <!-- Text column -->
        <div
          class="fsw-row-text flex flex-col items-center text-center lg:items-start lg:text-start"
          :class="i % 2 === 0 ? 'order-2 lg:order-1' : 'order-2 lg:order-2'">

          <!-- Label -->
          <span class="block w-fit text-heart-purple font-bold text-sm md:text-base tracking-wide mb-4 underline decoration-wavy decoration-heart-purple underline-offset-8">
            {{ $t(slide.labelKey) }}
          </span>

          <!-- Title -->
          <h3 class="text-[clamp(1.5rem,3vw,2.5rem)] font-black leading-[1.2] rtl:leading-[1.4] text-deep-indigo mb-4 md:mb-5">
            {{ $t(slide.titleKey) }}
          </h3>

          <!-- Description -->
          <p class="text-sm sm:text-base md:text-lg text-overcast-night leading-relaxed mb-6 md:mb-7 max-w-sm sm:max-w-md lg:max-w-none">
            {{ $t(slide.descKey) }}
          </p>

          <!-- Bullets -->
          <ul class="flex flex-col items-start gap-3 mb-7 md:mb-8 w-full max-w-sm sm:max-w-md lg:max-w-none">
            <li
              v-for="(bulletKey, j) in slide.bullets"
              :key="j"
              class="flex items-start gap-3 text-start text-sm md:text-base font-medium text-gray-900">
              <span class="flex-shrink-0 size-5 md:size-6 rounded-md border-2 border-gray-900 shadow-[2px_2px_0_#111827] flex items-center justify-center bg-heart-purple">
                <UIcon name="i-heroicons-check-20-solid" class="text-white size-3 md:size-3.5" />
              </span>
              {{ $t(bulletKey) }}
            </li>
          </ul>
        </div>

        <!-- Image column -->
        <div
          class="fsw-row-image flex justify-center"
          :class="i % 2 === 0 ? 'order-1 lg:order-2' : 'order-1 lg:order-1'">
          <div class="w-full max-w-sm sm:max-w-md lg:max-w-none rounded-2xl flex items-center justify-center">
            <img
              :src="slide.image"
              :alt="t(slide.titleKey)"
              class="w-full h-auto object-contain rounded-xl drop-shadow-md"
              loading="lazy">
          </div>
        </div>

      </div>
    </div>

  </section>
</template>
